function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 80,
  fill: "#FFD12C",
  rx: 5
}), /*#__PURE__*/React.createElement("g", {
  fill: "#010035"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.957 10H19l16 16.438L18.691 70H9.957L17.5 30.451z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.119 10h9.287L52.5 22.733 36.232 70h-9.113l8.03-43.562z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.592 10L52.5 22.733 44.592 70h9.042L70 19.158 54.166 10z"
})));

var SvgMiroIco = function SvgMiroIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMiroIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/miro_ico.f8bbc701.svg";
export { ForwardRef as ReactComponent };